import React from 'react';
import BrowserFrame from './BrowserFrame';
import { Crown, Clock, Building2 } from 'lucide-react';

const TEAL = '#02857E';

const bids = [
  { name: 'Apex Logistics', mc: 'MC-482931', amount: '$2,400', rank: 1 },
  { name: 'Coastline Freight', mc: 'MC-119045', amount: '$2,475', rank: 2 },
  { name: 'Summit Brokerage', mc: 'MC-203877', amount: '$2,520', rank: 3 },
  { name: 'Vector Transport', mc: 'MC-665201', amount: '$2,595', rank: 4 },
];

const LRDirectBoardMockup: React.FC<{ className?: string }> = ({ className }) => (
  <BrowserFrame url="app.lanerunner.com" className={className}>
    <div className="p-4 sm:p-5 grid grid-cols-1 md:grid-cols-5 gap-4">
      {/* Load card */}
      <div className="md:col-span-2 rounded-xl border border-gray-200 bg-white p-4">
        <div className="flex items-center justify-between mb-3">
          <span
            className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold text-white"
            style={{ backgroundColor: TEAL }}
          >
            <Crown className="h-2.5 w-2.5" /> LANERUNNER
          </span>
          <span className="inline-flex items-center gap-1 text-[10px] text-amber-600 font-semibold">
            <Clock className="h-3 w-3" /> 02:14:08
          </span>
        </div>
        <div className="text-xs text-gray-500 mb-0.5">Private network · Acme Foods</div>
        <div className="text-sm font-bold text-gray-900 leading-snug">
          Memphis, TN <span className="text-gray-400">→</span> Columbus, OH
        </div>
        <div className="flex items-center gap-2 mt-2 text-[11px] text-gray-600">
          <span className="px-1.5 py-0.5 rounded bg-gray-100">Reefer</span>
          <span>•</span>
          <span>553 mi</span>
          <span>•</span>
          <span>Pickup Tue</span>
        </div>
        <div className="mt-3 pt-3 border-t border-gray-100">
          <div className="text-[10px] text-gray-500 uppercase tracking-wider mb-1">Target</div>
          <div className="text-lg font-bold text-gray-900">$2,450</div>
        </div>
      </div>

      {/* Bids panel */}
      <div className="md:col-span-3 rounded-xl border border-gray-200 bg-white p-4">
        <div className="flex items-center justify-between mb-3">
          <h4 className="text-xs font-bold text-gray-900 uppercase tracking-wider">Live Bids</h4>
          <span className="text-[10px] text-gray-500">4 brokers</span>
        </div>
        <div className="space-y-2">
          {bids.map((b) => (
            <div
              key={b.mc}
              className={`flex items-center gap-3 p-2.5 rounded-lg border ${
                b.rank === 1 ? 'border-[#02857E]/40 bg-[#02857E]/5' : 'border-gray-100 bg-gray-50'
              }`}
            >
              <span
                className={`h-6 w-6 rounded-full inline-flex items-center justify-center text-[10px] font-bold ${
                  b.rank === 1 ? 'text-white' : 'bg-gray-200 text-gray-600'
                }`}
                style={b.rank === 1 ? { backgroundColor: TEAL } : undefined}
              >
                {b.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 text-xs font-semibold text-gray-900 truncate">
                  <Building2 className="h-3 w-3 text-gray-400 flex-shrink-0" />
                  {b.name}
                </div>
                <div className="text-[10px] text-gray-500">{b.mc}</div>
              </div>
              <div className="text-sm font-bold text-gray-900">{b.amount}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </BrowserFrame>
);

export default LRDirectBoardMockup;
